/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Deep_P3Inputs */

const en_diff_deep_p3 = /** @type {(inputs: Diff_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you care about identity rather than position, sort both arrays by a stable key before comparing, or compare the collections keyed by id instead of as arrays. The JSON Key Sorter handles object keys but deliberately leaves array order alone, so array normalization is something you have to do at the data level. For arrays whose order genuinely is the data, such as a ranking or a sequence of events, index matching is exactly right.`)
};

const ko_diff_deep_p3 = /** @type {(inputs: Diff_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`위치가 아니라 정체성이 중요하다면, 비교 전에 안정적인 키로 양쪽 배열을 정렬하거나, 배열이 아니라 id로 키를 부여한 컬렉션으로 비교하세요. JSON Key Sorter는 객체 키를 처리하지만 배열 순서는 의도적으로 그대로 두므로, 배열 정규화는 데이터 수준에서 해야 합니다. 순위나 이벤트 순서처럼 순서 자체가 데이터인 배열이라면 인덱스 대응이 정확히 맞습니다.`)
};

const ja_diff_deep_p3 = /** @type {(inputs: Diff_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置ではなく同一性が重要なら、比較の前に安定したキーで両方の配列を並べ替えるか、配列ではなく id をキーにしたコレクションとして比較してください。JSON Key Sorter はオブジェクトキーを扱いますが配列順序は意図的にそのままにするので、配列の正規化はデータのレベルで行う必要があります。順位やイベントの並びのように順序そのものがデータである配列なら、添字対応がまさに正解です。`)
};

/**
* | output |
* | --- |
* | "When you care about identity rather than position, sort both arrays by a stable key before comparing, or compare the collections keyed by id instead of as ar..." |
*
* @param {Diff_Deep_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_deep_p3 = /** @type {((inputs?: Diff_Deep_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Deep_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_deep_p3(inputs)
	if (locale === "ko") return ko_diff_deep_p3(inputs)
	return ja_diff_deep_p3(inputs)
});